import { nowInstant } from "@nijiurachan/js/util/time";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { BOARD_CONFIG } from "@/config/browserBoard";
import {
  type ThreadLimits,
  threadLimitsRefetchInterval,
} from "@/features/thread/utils/threadExpiry";
import { apiGet } from "@/shared/api";

const THREAD_LIMITS_QUERY_BEHAVIOR = {
  staleTime: 30_000,
  refetchOnWindowFocus: "always" as const,
  refetchIntervalInBackground: false,
};

/**
 * スレ寿命上限は板のアクティブスレ数に依存する。総合カタログのスレ立てで
 * 板を切り替えるため、対象slugを指定できる(省略時は現在板)。
 */
export function useThreadLimits(slug?: string): UseQueryResult<ThreadLimits> {
  const boardSlug = slug ?? BOARD_CONFIG.boardKey;
  return useQuery({
    queryKey: ["thread-limits", boardSlug],
    queryFn: () =>
      // backendはX-Board-Keyをパスslugより優先するため対象板keyを揃える
      apiGet<ThreadLimits>(`/thread-limits/${encodeURIComponent(boardSlug)}`, {
        cache: "no-store",
        boardKey: boardSlug,
      }),
    ...THREAD_LIMITS_QUERY_BEHAVIOR,
    refetchInterval: (query: { state: { data: ThreadLimits | undefined } }) =>
      threadLimitsRefetchInterval(query.state.data, nowInstant()),
  });
}
